import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { CustomValidationService } from "src/app/cbta-web/services/custom-validation.service";
import { UtilityService } from "src/app/util/utility.service";
import { SharedService } from "../../services/shared.service";

@Component({
	selector: "app-cbta-signoff-modal",
	templateUrl: "./cbta-signoff-modal.component.html",
	styleUrls: ["./cbta-signoff-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaSignoffModalComponent implements OnInit {
	signOffForm!: UntypedFormGroup;

	showSecret: boolean = false;

	/** When set, Staff Id is prefilled and locked to the authenticated pilot. */
	@Input() lockedStaffNumber = "";

	@Output() signoffFormValue: EventEmitter<any> = new EventEmitter<any>();

	constructor(
		private fb: UntypedFormBuilder,
		public sharedService: SharedService,
		private utilService: UtilityService,
		public customValidationService: CustomValidationService,
	) {}

	ngOnInit(): void {
		const lockedStaff = (this.lockedStaffNumber ?? "").toString().trim();

		this.signOffForm = this.fb.group({
			staffNumber: [{ value: lockedStaff, disabled: !!lockedStaff }, [Validators.required]],
			secretKey: ["", [Validators.required]],
		});

		this.signOffForm.get("secretKey")?.valueChanges.subscribe(() => {
			this.emitSignOffValue();
		});
	}

	get secretKey() {
		return this.signOffForm.get("secretKey")!;
	}

	get staffNumber() {
		return this.signOffForm.get("staffNumber")!;
	}

	get isStaffNumberLocked(): boolean {
		return !!this.staffNumber.disabled;
	}

	showHideSecret(): void {
		this.showSecret = !this.showSecret;
	}

	private emitSignOffValue(): void {
		const staffNumber = this.signOffForm.getRawValue()?.staffNumber ?? this.signOffForm.get("staffNumber")?.value;
		const secretKey = this.signOffForm.get("secretKey")?.value;
		this.signoffFormValue.emit({
			staffNumber,
			secretKey: secretKey ? this.utilService.encrypt(secretKey) : "",
		});
	}
}
